import React from "react";
import Header from "../components/Header";
import Footer from "./Footer";
import { useMediaQuery } from "react-responsive";

export default function AboutUs() {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 769px)",
  });

  return (
    <>
      <div>
        <Header />
        <div className="pre-main-2022">
          <img
            src={
              isDesktopOrLaptop
                ? "images/about-image.jpg"
                : "images/about-mobile.jpg"
            }
          />
        </div>

        <h3 className="about-title">ما سرمایه‌گذاری را آسان کرده‌ایم</h3>
        <div className="about-par">
          طلایی‌شو پلت‌فرم آنلاین خرید و فروش شمش طلا و نقره و دارای مجوز اینماد
          و دارای پروانه کسب سامانه معاملات آنلاین طلای آب شده و مصنوعات طلا و
          نقره و جواهر از دبیرخانه هیأت عالی نظارت بر سازمان های صنفی کشور است
          که در زمستان ۱۴۰۰ راه‌اندازی شد. در این پلت‌فرم با هر میزان بودجه
          می‌توانید از یک گرم تا چند کیلوگرم طلا و نقره ۲۴ عیار بخرید، بفروشید و
          سود کنید. خرید و فروش طلا و نقره ی بیمه‌شده بدون محدودیت بودجه یا
          مقدار طلا و نقره و معامله با کمترین کارمزد، امکاناتی است که طلایی‌شو
          فراهم کرده تا راحت‌تر سرمایه‌گذاری کنید. طلا و نقره ی خریداری‌شده شما
          در صندوق‌های امن نگهداری می‌شود. در صورت تمایل می‌توانید طلا و نقره ی
          خود را به صورت حضوری تحویل بگیرید.
        </div>
        <Footer />
      </div>
    </>
  );
}
